const mainConfigurationView = {
  templateUrl: '/modules/configurationManagement/main-configuration-view/main-configuration-view.html',
  controller: 'MainConfigurationViewController',
};

angular
    .module('configuration-management.module')
    .component('mainConfigurationView', mainConfigurationView)
    .config(function ($stateProvider) {
        $stateProvider
            .state('train', {
                url: '/train/:consist',
                redirectTo: 'train.overview',
                component: 'mainConfigurationView',
                resolve: {
                    auth: function (userService, $state, eventService) {
                        return userService
                            .resolve(['ACCESS_DASHBOARD'])
                            .then(() => {
                            })
                            .catch(() => {
                                eventService.trigger('userservice:unauthorized');
                                $state.go('frontpage');
                            });
                    },
                }
            });
    });